import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['sidebar', 'overlay', 'mobileBtn']

  connect () {
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect () {
    document.removeEventListener('keydown', this.boundCloseOnEscape)
  }

  toggleMobile () {
    if (this.sidebarTarget.classList.contains('mobile-open')) {
      this.close()
    } else {
      this.open()
    }
  }

  open () {
    this.sidebarTarget.classList.add('mobile-open')
    this.overlayTarget.classList.add('active')
    document.addEventListener('keydown', this.boundCloseOnEscape)

    // Prevent body scroll when sidebar is open
    document.body.style.overflow = 'hidden'
  }

  close () {
    this.sidebarTarget.classList.remove('mobile-open')
    this.overlayTarget.classList.remove('active')
    document.removeEventListener('keydown', this.boundCloseOnEscape)

    // Restore body scroll
    document.body.style.overflow = ''
  }

  closeOnOverlay () {
    this.close()
  }

  closeOnEscape (event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
}
